var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gradient-to-l from-sky-100 to-blue-100 text-gray-900 min-h-screen",attrs:{"id":"app"}},[_c('Header'),_c('Position'),_c('SearchForm'),_c('PetrolstationList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }